// Copyright 2025, University of Maryland, All Rights Reserved
/** Shared formatting helpers for the I-9 dashboard. */

/** Format an ISO timestamp for display in the local timezone, or '—' when missing/unparseable. */
export function formatTimestamp(iso: string | null | undefined): string {
  if (!iso) return '—'
  const date = new Date(iso)
  return isNaN(date.getTime()) ? '—' : date.toLocaleString()
}
